import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { createBrowserHistory } from 'history';

import BrandDash from './BrandDash';
import NavLinks from './NavLinks';
import Dashbox from './Dashbox';
import CreateBoard from './CreateBoard';

import { auth, boards } from '../actions';

// const local = 'http://localhost:8000';
const prod = 'https://byteapp.herokuapp.com';
const url = prod;
const history = createBrowserHistory();
const location = history.location;

class Dashbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      apps: [],
      show: false,
      title: '',
    };
  }
  componentDidMount() {
    axios.get(url+'/api/')
    .then(res => {
      const apps = res.data;
      this.setState({ apps });
    });
  }

  showModal = () => {
    this.setState({ show: true });
  };
  hideModal = () => {
    this.setState({ show: false });
  };

  resetForm = () => {
    this.setState({title: ''});
  }

  handleTitle = e => {
    e.preventDefault();
    this.setState({ title: e.target.value });
  }

  onSubmit = e => {
    e.preventDefault();
    if (this.state.title) {
      this.props.createBoard(this.state.title);
      window.analytics.track("Board Created", {
        board: this.state.title,
      });
      this.resetForm();
    }
    history.push('/browse');
    window.location.reload();
  }

  

  render() {
    if (this.props.user.username) {
      return(
        <header className="App-header">
          <BrandDash />
          <NavLinks />
          <Dashbox className="search" type="text" placeholder="search apps" items={this.state.apps.map(app => app)} onChange={this.handleChange} />
          <ul className="account dropdown">
            <li className="name">{this.props.user.username} <i className="fa fa-angle-down"></i></li>
            <div className="dropdown-box">
              <li><button className="btn" onClick={this.showModal}>Create Stacks</button></li>
              <li><a href="https://medium.com/pinstripe/getting-started-with-pinstripe-3d5f6d9ebb7" target="_blank" rel="noopener noreferrer">Getting Started</a></li>
              {/*<li><a href="https://in.hotjar.com/s?siteId=1061910&surveyId=119633" target="_blank" rel="noopener noreferrer">Have Feedback?</a></li>*/}
              <li><Link to='/update'>Update Password</Link></li>
              {/*<li><a href="mailto:hello@pinstripelabs.com">Contact Support</a></li>*/}
              <li><a onClick={this.props.logout}>Sign Out</a></li>
            </div>
          </ul>
          <CreateBoard show={this.state.show} handleClose={this.hideModal} onSubmit={this.onSubmit} handleInput={this.handleTitle} resetInput={this.resetForm} />
        </header>
      );
    } else {
      return(
        <header className="App-header">
          <BrandDash />
          <NavLinks />
          <Dashbox className="search" type="text" placeholder="search apps" items={this.state.apps.map(app => app)} onChange={this.handleChange} />
          <ul className="account">
            <Link className="btn" to="/signin">Sign In</Link>
          </ul>
        </header>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
  }
}

const mapStateToDispatch = dispatch => {
  return {
    createBoard: (title) => {
      return dispatch(boards.createBoard(title));
    },
    logout: () => dispatch(auth.logout()),
  }
}

export default connect(mapStateToProps, mapStateToDispatch)(Dashbar);


// WEBPACK FOOTER //
// ./src/components/Dashbar.js